import { sizes, colors } from "assets/constants";
import { Platform, StyleSheet } from "react-native";
import css from "styles";
import { mq, sn } from "utils";

export const styles = StyleSheet.create({
  item: {
    width: "80%",
    height: mq(55),
    alignSelf: "center",
    alignItems: "center",
    justifyContent: "center",
  },

  inputContainer: {
    width: "100%",
    height: sn(43, 48, 48, 48),
    borderWidth: 1,
    flexDirection: "row",
    alignItems: "center",
    borderColor: colors.border,
    borderRadius: sizes.radius.lg,
    backgroundColor: colors.itemsBg,
  },

  textContainer: { flex: 1, paddingRight: mq(2) },

  iconContainer: {
    height: "100%",
    width: sizes.isMediumScreen ? 40 : 45,
    alignItems: "center",
    justifyContent: "center",
  },

  errorContainer: {
    width: "100%",
    alignSelf: "flex-end",
    height: mq(20),
    paddingHorizontal: mq(5),
    bottom: Platform.OS === "web" ? mq(-2) : mq(3),
  },

  searchInputContainer: { width: "100%", paddingHorizontal: 10 },

  searchInput: {
    borderWidth: 0,
    borderRadius: 0,
    borderBottomWidth: 2,
  },

  modalBtnContainer: {
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: sizes.space,
    paddingVertical: 2 * sizes.space,
    backgroundColor: colors.itemsBg,
  },

  calendarContainer: {
    width: "100%",
    maxWidth: 400,
    aspectRatio: 1,
    alignSelf: "center",
  },

  // -------------------

  container: {
    width: "100%",
    height: mq(50),
    borderWidth: 1,
    flexDirection: "row",
    alignItems: "center",
    borderColor: colors.border,
    borderRadius: sizes.radius.lg,
    backgroundColor: colors.itemsBg,
  },

  modal: { margin: 0 },

  modalContainer: {
    flex: 1,
    width: "100%",
    ...css.containerMaxWidth,
    alignSelf: "center",
    maxHeight: "90%",
  },

  topGap: {
    flex: 1,
    minHeight: mq(20),
    backgroundColor: colors.transparent,
  },

  listContainer: {
    // flex: 1,
    // minHeight: 70,
    // minHeight: mq(50),
    elevation: 10,
    borderTopLeftRadius: sizes.radius.lg,
    borderTopRightRadius: sizes.radius.lg,
    ...(sizes.isMediumScreen && { borderRadius: sizes.radius.lg }),
    borderTopWidth: 3,
    borderRightWidth: 1,
    borderLeftWidth: 1,
    borderColor: colors.border,
    backgroundColor: colors.itemsBg,
  },

  list: { flexGrow: 1, paddingBottom: sizes.space },

  listSearchContainer: {
    width: "100%",
    paddingHorizontal: "5%",
    // paddingVertical: sizes.space,
  },

  itemSeparator: {
    height: 1,
    width: "80%",
    alignSelf: "center",
    backgroundColor: colors.border,
  },
});
